module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 rounded-b relative h-56",
    class: [_vm.user_speaker || _vm.on_queue ? '' : 'rounded-t'],
    on: {
      "click": _vm.openStudentAssessment
    }
  }, [(_vm.currentTurn.id) ? _c('div', {
    staticClass: "absolute left-0 bottom-0 top-0 right-0 z-20 w-full h-full"
  }, [_c('div', {
    staticClass: "relative w-full h-full"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-2 h-full"
  }, [(_vm.currentTurn.queue_position === 0) ? _c('div', {
    staticClass: "bg-gray-900 bg-opacity-50 backdrop-blur-lg font-poppins text-xs py-0.5 text-white text-center"
  }, [_vm._v("\n          Speaker\n        ")]) : _vm._e(), _vm._v(" "), (_vm.currentTurn.queue_position > 0 && _vm.currentTurn.queue_position < 999998) ? _c('div', {
    staticClass: "bg-gray-600 bg-opacity-50 backdrop-blur-lg font-poppins text-xs py-0.5 text-white text-center"
  }, [_vm._v("\n          Queue #" + _vm._s(_vm.queueIndex) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col px-2 space-y-1"
  }, [_c('div', {
    staticClass: "flex justify-between items-center",
    class: {
      'pt-2': _vm.currentTurn.queue_position === 999999
    }
  }, [_c('div', {
    staticClass: "rounded-tr-full rounded-br-full rounded-tl-full cursor-pointer flex items-center space-x-2 px-3 py-1",
    class: [_vm.generateTurnPhrases(_vm.currentTurn.turn_type).backgroundColor, _vm.turn_description ? 'cursor-pointer' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleOpenDetailsTurn()
      },
      "mouseenter": function($event) {
        _vm.is_hovering_turn = true
      },
      "mouseleave": function($event) {
        _vm.is_hovering_turn = false
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.determineTurnTypeIconHTML(_vm.currentTurn.turn_type))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-white text-xs font-poppins font-medium"
  }, [_vm._v(_vm._s(_vm.generateTurnPhrases(_vm.currentTurn.turn_type).title))])]), _vm._v(" "), (_vm.speaking_participants[_vm.participation.user.id]) ? _c('div', [_c('VolumeIndicator')], 1) : _vm._e()]), _vm._v(" "), ((_vm.is_hovering_turn === true && _vm.turn_description !== null) || _vm.is_turn_opened === true) ? _c('div', {
    staticClass: "bg-opacity-60 px-3 py-1 text-xs mt-1 rounded-tr-lg rounded-br rounded-bl text-white",
    class: [_vm.generateTurnPhrases(_vm.currentTurn.turn_type).backgroundColor, _vm.turn_description ? 'cursor-pointer' : '']
  }, [_vm._v("\n            " + _vm._s(_vm.turn_description) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow px-2 h-full",
    on: {
      "mouseenter": function($event) {
        _vm.activeMoreOptions = true
      },
      "mouseleave": function($event) {
        _vm.activeMoreOptions = false
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col h-full justify-end"
  }, [(_vm.activeMoreOptions) ? _c('div', {
    staticClass: "flex justify-between items-center space-x-2"
  }, [(_vm.hasTeacherPermissionsInCourse || _vm.user_is_moderator) ? _c('div', [(_vm.user_speaker) ? _c('button', {
    staticClass: "sample px-3.5 disabled:opacity-50 py-2 flex items-center justify-center space-x-2 rounded-full bg-red-500 text-white",
    attrs: {
      "disabled": _vm.loading_queue
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeSpeaker(_vm.participation.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-flag-checkered"
  }), _vm._v(" "), _c('span', [_vm._v("End Turn")])]) : (_vm.on_queue) ? _c('button', {
    staticClass: "sample px-3.5 py-2 disabled:opacity-50 flex items-center justify-center space-x-2 rounded-full bg-white shadow hover:bg-gray-100 text-blueGray-800",
    attrs: {
      "disabled": _vm.loading_queue
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.leaveQueue(_vm.participation.user.id, _vm.currentTurn.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-user-minus"
  }), _vm._v(" "), _c('span', [_vm._v("Remove")])]) : _c('button', {
    staticClass: "sample px-4 py-2 flex items-center justify-center space-x-2 rounded-full bg-white hover:bg-gray-100 shadow text-blueGray-800",
    attrs: {
      "disabled": _vm.loading_queue
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addToQueue(_vm.currentTurn.id)
      }
    }
  }, [(!_vm.currentSpeaker.id && !_vm.on_queue) ? _c('div', [_c('i', {
    staticClass: "fa-solid fa-bullhorn"
  }), _vm._v(" "), _c('span', [_vm._v("Make Speaker")])]) : _c('div', [_c('i', {
    staticClass: "fa-solid fa-user-plus"
  }), _vm._v(" "), _c('span', [_vm._v("Add to Queue")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [(_vm.currentTurn.id && !_vm.user_speaker && _vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "sample px-4 disabled:opacity-50 py-2.5 flex items-center justify-center space-x-2 rounded-full bg-red-500 text-white",
    attrs: {
      "disabled": _vm.isTappingOut
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.teacherRemoveStudentFromCircle(_vm.participation.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-arrow-up-from-bracket rotate-270"
  })]) : _vm._e(), _vm._v(" "), (_vm.user_speaker && !_vm.is_my_participation) ? _c('button', {
    staticClass: "sample px-2.5 py-1.5 flex items-center justify-center space-x-2 rounded-full shadow bg-white bg-opacity-90",
    attrs: {
      "disabled": _vm.is_my_participation
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addToApplauseArray.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                  🙌\n                ")]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pb-2 px-2"
  }, [_c('div', {
    staticClass: "flex w-full justify-between items-center overflow-x-hidden"
  }, [_c('div', {
    staticClass: "flex items-center space-x-1"
  }, [(_vm.currentTurn.id && _vm.audio_video_is_active && _vm.joinedAudioDiscussion && _vm.student_joined_LD && !_vm.is_my_participation && (_vm.user_is_moderator || _vm.hasTeacherPermissionsInCourse)) ? _c('button', {
    staticClass: "flex space-x-1.5 bg-gray-800 text-white hover:bg-white shadow h-7 hover:text-blueGray-800 bg-opacity-50 rounded-full px-2.5 py-1.5 items-center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.muteStudentParticipation(_vm.participation)
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid text-xs",
    class: [_vm.participation.audio_is_enabled ? 'fa-microphone' : 'fa-microphone-slash']
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-0.5 bg-gray-800 bg-opacity-50 cursor-default rounded-full px-3 h-7 py-1 items-center"
  }, [(_vm.is_my_participation) ? _c('span', {
    staticClass: "text-white text-xs"
  }, [_vm._v("You")]) : _c('div', {
    staticClass: "text-white cursor-default text-xs max-width-name truncate",
    attrs: {
      "title": _vm.participation.user.name
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.first_name))])]), _vm._v(" "), (_vm.user_moderator_icon) ? _c('i', {
    staticClass: "fa-solid text-xs text-white fa-gavel ml-0.5"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-1.5"
  }, [(_vm.currentTurn.id && !_vm.user_speaker && _vm.currentTurn.turn_type !== 'video_audio_on') ? _c('button', {
    staticClass: "sample hover:bg-orange-700 h-7 flex items-center bg-opacity-50 rounded-full text-white space-x-1.5 px-2.5 py-1",
    class: [_vm.is_my_participation ? 'cursor-default' : 'cursor-pointer', _vm.encourager_count ? 'bg-orange-700' : 'bg-gray-800'],
    attrs: {
      "disabled": _vm.is_my_participation
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.encourageStudent()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-ear-listen",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.encourager_count))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-800 text-xs cursor-default flex items-center bg-opacity-50 rounded-full text-white space-x-1.5 h-7 px-2.5 py-1"
  }, [_c('i', {
    staticClass: "fa-solid fa-bullhorn text-xs",
    staticStyle: {
      "font-size": "10px"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.participation.turn_count))])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "absolute",
    staticStyle: {
      "top": "calc(50% - 30px)",
      "left": "calc(50% - 35px)"
    }
  }, [_c('img', {
    staticClass: "rounded-full object-cover",
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": _vm.participation.user.avatar_url
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-1d8f4c74!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/LDDiscussionCircle.vue
// module id = 1769
// module chunks = 61